<template>
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="35"
      height="35"
      rx="17.5"
      fill="#FFB61D"
      fill-opacity="0.2"
    />
    <path
      d="M16.9105 6.36984L16.9102 6.37034L6.75407 23.9483C6.75403 23.9483 6.75399 23.9484 6.75395 23.9485C6.4921 24.4044 6.8202 24.9703 7.34364 24.9703H27.6561C28.1796 24.9703 28.5077 24.4044 28.2458 23.9485L16.9105 6.36984ZM16.9105 6.36984C17.04 6.14258 17.2688 6.02969 17.4999 6.02969C17.7304 6.02969 17.9574 6.14223 18.0896 6.37045L28.2457 23.9483L16.9105 6.36984ZM17.5865 8.80691L17.4999 8.65702L17.4133 8.80691L9.1174 23.1673L9.03073 23.3173H9.20399H25.7958H25.969L25.8824 23.1673L17.5865 8.80691ZM16.7419 21.3361C16.5409 21.135 16.428 20.8624 16.428 20.5781C16.428 20.2938 16.5409 20.0212 16.7419 19.8202C16.943 19.6192 17.2156 19.5063 17.4999 19.5063C17.7842 19.5063 18.0568 19.6192 18.2578 19.8202C18.4588 20.0212 18.5718 20.2938 18.5718 20.5781C18.5718 20.8624 18.4588 21.135 18.2578 21.3361C18.0568 21.5371 17.7842 21.65 17.4999 21.65C17.2156 21.65 16.943 21.5371 16.7419 21.3361ZM16.8186 17.6484V13.1562C16.8186 13.1041 16.8617 13.0609 16.9139 13.0609H18.0858C18.138 13.0609 18.1811 13.1041 18.1811 13.1562V17.6484C18.1811 17.7006 18.138 17.7437 18.0858 17.7437H16.9139C16.8617 17.7437 16.8186 17.7006 16.8186 17.6484Z"
      fill="#FBBA13"
      stroke="#FFF0D2"
      stroke-width="0.2"
    />
  </svg>
</template>
